<div class="pr-3 py-4 pl-4 h-full w-full flex flex-col">
    <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    <div class="mt-3 mb-6 text-2xl font-medium">Project Settings</div>
    <form class="project-form"
          (ngSubmit)="submitForm()"
          [formGroup]="projectForm">
        <div class="form-group">
            <label class="label">
                Name
            </label>
            <input class="form-input"
                   placeholder="Project Name"
                   formControlName="name"
                   jAutofocus />
        </div>
        <div class="form-group mt-3">
            <label class="label">
                URL
            </label>
            <input class="form-input"
                   placeholder="Project URL"
                   formControlName="url" />
        </div>
        <div class="form-group mt-3">
            <label class="label">
                Category
            </label>
            <select class="form-input"
                    formControlName="category">
                <option *ngFor="let category of categories">
                    {{ category }}
                </option>
            </select>
        </div>
        <div class="form-group mt-3">
            <label class="label">
                Description
            </label>
            <textarea class="form-input"
                      placeholder="Project Description"
                      formControlName="description">
            </textarea>
        </div>
        <div class="form-group mt-3">
            <j-button className="btn-primary mr-2"
                      type="submit"
                      [disabled]="projectForm.invalid">
                Save
            </j-button>
            <j-button className="btn-empty"
                      (click)="cancel()">
                Cancel
            </j-button>
        </div>
    </form>
</div>